import React from 'react';
import PropTypes from 'prop-types';
import MaterialList from 'material-ui/List/List';

const List = (props) => {
    const {
        children,
        style,
    } = props;

    return (
        <MaterialList
            style={ style }
        >
            { children }
        </MaterialList>
    );
};

List.propTypes = {
    children: PropTypes.node.isRequired,
    style: PropTypes.object,
};

export default List;



// WEBPACK FOOTER //
// ./src/components/ui/list/List.js